import { render, staticRenderFns } from "./MenuModalForm.vue?vue&type=template&id=f915ffd0"
import script from "./MenuModalForm.vue?vue&type=script&lang=js"
export * from "./MenuModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports